<template>
  <layout title="Classrooms">
    <div class="row">
      <div class="col-md-10">
        <h4>Classroom Sessions</h4>
      </div>
      <div class="col-md-2">
        <inertia-link
          :href="route('classrooms.assigned.view.sessions', classroom.data.id)"
          class="btn btn-sm btn-primary float-right"
          :only="['sessions']"
        >
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-arrow-repeat"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"
            />
            <path
              fill-rule="evenodd"
              d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
            />
          </svg>
          Refresh
        </inertia-link>
      </div>
    </div>
    <hr />

    <FlashMessage :flash="flash" />

    <div class="row">
      <div
        v-for="session in sessions.data"
        :key="session.id"
        class="col-md-4 mb-3"
      >
        <div class="border p-3">
          <h5>
            {{ session.start_datetime }}
          </h5>
          End:
          {{ session.end_datetime }}

          <span
            v-if="session && session.metadata && session.metadata.live"
            title="Live Classroom Session"
            class="badge badge-danger live-class"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-camera-video-fill"
              viewBox="0 0 16 16"
              width="12"
              height="12"
            >
              <path
                fill-rule="evenodd"
                d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5z"
              ></path>
            </svg>
          </span>

          <div role="alert" class="mt-2 mb-0 alert alert-light">
            <span v-if="session.data.is_past">Ended</span>
            <span v-if="session.data.is_future">In</span>
            <span v-if="session.data.is_inprogress">Started</span>
            {{ session.data.time_difference }}
          </div>

          <inertia-link
            :href="
              route('classrooms.assigned.sessions.join', [
                classroom.data.id,
                session.id,
              ])
            "
            :disabled="!session.data.is_inprogress"
            class="mt-3 btn btn-sm"
            :class="{
              'btn-success': session.data.is_inprogress,
              'btn-outline-success': !session.data.is_inprogress,
              disabled: !session.data.is_inprogress,
            }"
          >
            Join Session
          </inertia-link>

          <inertia-link
            v-if="permissions.add_content"
            :href="route('classrooms.sessions.content', session.id)"
            class="ml-3 mt-3 btn btn-sm btn-outline-primary"
          >
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-gear-fill"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 0 0-5.86 2.929 2.929 0 0 0 0 5.858z"
              />
            </svg>
            Add content
          </inertia-link>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import ClassroomLayout from "../../Layouts/ClassroomLayout";
import moment from "moment";

export default {
  layout: [AppLayout, ClassroomLayout],
  props: {
    classroom: Object,
    sessions: Object,
    flash: Object,
    permissions: {
      add_content: Boolean,
    },
  },
  data() {},
  methods: {
    moment() {
      return moment;
    },
  },
};
</script>